@import (reference) '../../../../../../constants/spacing.module.less';

.gift-indicator {
  display: flex;
  gap: @space-8;
  align-items: center;
  background-color: var(--success--background-color--4);
  padding: @space-4 @space-8;
  border-radius: 4px;
  color: var(--default--text-color--18);
}

.icon {
  height: 16px;
  color: var(--success--icon--fill-color--2);
}
